// Generated by scripts/styles/generate-public-styles.mjs. Do not edit.
export const publicStylesHref = "/styles/public.78bd89493070ac1b.css"
export const articleStylesHref = "/styles/article-critical.3fee0aa199f15919.css"
export const productStylesHref = "/styles/product-critical.bdb5c9b51ecd1214.css"
export const compareStylesHref = "/styles/compare-critical.d0f0da5dd3fdc0a8.css"
